import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const input = "w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-gold";

export function ChangePasswordCard() {
  const [f, setF] = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!f.currentPassword) errs.currentPassword = "Inserisci la password attuale";
    if (f.newPassword.length < 6) errs.newPassword = "Minimo 6 caratteri";
    if (f.confirm !== f.newPassword) errs.confirm = "Le password non coincidono";
    setErr(errs);
    if (Object.keys(errs).length) return;
    setLoading(true);
    try {
      const r = await api.post("/auth/change-password", { currentPassword: f.currentPassword, newPassword: f.newPassword });
      localStorage.setItem("aic_token", r.data.token);
      toast.success("Password aggiornata");
      setF({ currentPassword: "", newPassword: "", confirm: "" });
    } catch (e2) {
      const msg = e2?.response?.data?.detail;
      setErr({ currentPassword: typeof msg === "string" ? msg : "Errore" });
    } finally { setLoading(false); }
  };

  const field = (k, label) => (
    <div>
      <label className="overline text-slate-500 mb-2 block">{label}</label>
      <input data-testid={`cp-${k}`} type="password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${input} ${err[k] ? "field-error" : ""}`} />
      {err[k] && <div className="field-error-text" data-testid={`cp-${k}-error`}>{err[k]}</div>}
    </div>
  );

  return (
    <form onSubmit={submit} noValidate className="mt-10 card-premium p-6" data-testid="change-password-card">
      <div className="flex items-center gap-2 mb-4"><KeyRound className="w-5 h-5 text-gold" /><h3 className="font-display text-xl font-bold">Cambia password</h3></div>
      <div className="grid md:grid-cols-3 gap-4">
        {field("currentPassword", "Password attuale")}
        {field("newPassword", "Nuova password")}
        {field("confirm", "Conferma nuova password")}
      </div>
      <button data-testid="cp-submit" disabled={loading} className="btn-pill-gold mt-5 text-sm">{loading ? "Salvataggio…" : "Aggiorna password"}</button>
    </form>
  );
}
